import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-card-dropdown',
  templateUrl: './admin-card-dropdown.component.html',
  styleUrls: ['./admin-card-dropdown.component.scss']
})
export class AdminCardDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
